import React from 'react';
import { Check } from 'lucide-react';

interface WizardStepperProps {
  currentStep: number;
  totalSteps: number;
}

const WizardStepper: React.FC<WizardStepperProps> = ({ currentStep, totalSteps }) => {
  return (
    <div className="flex items-center justify-center gap-[10px] mb-9">
      {Array.from({ length: totalSteps }, (_, i) => {
        const step = i + 1;
        const isCompleted = step < currentStep;
        const isActive = step === currentStep;

        return (
          <React.Fragment key={step}>
            {i > 0 && <div className="w-8 h-0.5 bg-[#e2e8f0]" />}
            {isCompleted ? (
              <div className="w-[10px] h-[10px] rounded-full bg-[#22c55e] flex items-center justify-center">
                <Check size={7} className="text-white" strokeWidth={3} />
              </div>
            ) : (
              <div
                className={`rounded-full ${
                  isActive
                    ? 'w-[10px] h-[10px] bg-[#1F467E]'
                    : 'w-2 h-2 bg-[#cbd5e1]'
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default WizardStepper;
